<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showClient") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #E1423D">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper d-flex justify-content-between">
        <!-- <div class="wrapper">
          <v-chip color="amber darken-2" text-color="white">
            {{ $t("TITLES.numberOfVisits", { number: data.numberOfVisits }) }}
          </v-chip>
          <v-chip color="amber darken-2 mx-2" text-color="white">
            {{ $t("TITLES.lastVisit", { date: data.lastVisit }) }}
          </v-chip>
        </div> -->
        <div></div>
        <v-chip :color="data.is_active ? 'green' : 'red'" text-color="white">
          {{ data.is_active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->
      <form>
        <div class="row">
          <!-- Start:: Personal Image Display -->
          <div
            class="preview-container text-center my-3"
            :class="data.user_type === 'company' ? 'col-md-4 col-12' : 'col-12'"
            v-if="data.image && data.image != 'https://backend.drznshop.com/assets/avatar.png'"
          >
            <p for="image" class="image-label">
              {{ $t("PLACEHOLDERS.personalImage") }}
            </p>
            <div class="image-wrapper mt-3" @click="showImageModal(data.image)">
              <img
                style="width: 150px; height: 150px; object-fit: contain;"
                :src="data.image"
                :alt="$t('PLACEHOLDERS.personalImage')"
                class="preview-image"
              />
              <div class="image-overlay">
                <i class="fas fa-expand"></i>
                <span>{{ $t("ACTIONS.viewFullSize") || "View Full Size" }}</span>
              </div>
            </div>
          </div>
          <!-- End:: Personal Image Display -->

          <!-- Start:: Commercial Registration Image Display -->
          <div
            class="preview-container text-center my-3 col-md-4 col-12"
            v-if="data.commercial_registration_image && data.user_type === 'company'"
          >
            <p for="image" class="image-label">
              {{ $t("PLACEHOLDERS.commercial_registration_image") || "Commercial Registration Image" }}
            </p>
            <div class="image-wrapper mt-3" @click="showImageModal(data.commercial_registration_image)">
              <img
                style="width: 150px; height: 150px; object-fit: contain;"
                :src="data.commercial_registration_image"
                :alt="$t('PLACEHOLDERS.commercial_registration_image') || 'Commercial Registration Image'"
                class="preview-image"
              />
              <div class="image-overlay">
                <i class="fas fa-expand"></i>
                <span>{{ $t("ACTIONS.viewFullSize") || "View Full Size" }}</span>
              </div>
            </div>
          </div>
          <!-- End:: Commercial Registration Image Display -->

          <!-- Start:: Tax Number Image Display -->
          <div
            class="preview-container text-center my-3 col-md-4 col-12"
            v-if="data.tax_number_image && data.user_type === 'company'"
          >
            <p for="image" class="image-label">
              {{ $t("PLACEHOLDERS.tax_number_image") || "Tax Number Image" }}
            </p>
            <div class="image-wrapper mt-3" @click="showImageModal(data.tax_number_image)">
              <img
                style="width: 150px; height: 150px; object-fit: contain;"
                :src="data.tax_number_image"
                :alt="$t('PLACEHOLDERS.tax_number_image') || 'Tax Number Image'"
                class="preview-image"
              />
              <div class="image-overlay">
                <i class="fas fa-expand"></i>
                <span>{{ $t("ACTIONS.viewFullSize") || "View Full Size" }}</span>
              </div>
            </div>
          </div>
          <!-- End:: Tax Number Image Display -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.service_requester_name')"
            v-model.trim="data.client_name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_registration_number')"
            v-model.trim="data.commercial_registration_number"
            disabled
            v-if="data.user_type === 'company'"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.region')"
            v-model.trim="data.region_name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city_name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district_name"
            disabled
          />
          <base-input
            v-if="data.email"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.joiningDate')"
            v-model.trim="data.created_at"
            disabled
          />
          <base-input
            ref="phoneInput"
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            disabled
          />
          <div class="col-12 my-5">
            <label class="preview-container-label d-block">{{
              $t("PLACEHOLDERS.map_location")
            }}</label>
            <MapComponent
              :lat="parseFloat(data.latitude)"
              :lng="parseFloat(data.longitude)"
            />
          </div>
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.postal_code')"
            v-model.trim="data.postal_code"
            disabled
            v-if="data.user_type === 'company'"
          /> -->
          </div>
        </form>
      </div>
    <!-- END:: Single Step Form Content -->

    <!-- Start:: Image Modal -->
    <image-modal
      v-if="dialogImage"
      :modalIsOpen="dialogImage"
      :modalImage="selectedItemImage"
      @toggleModal="dialogImage = false"
    />
    <!-- End:: Image Modal -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";
import MapComponent from "@/components/general/MapComponent";

export default {
  name: "ShowClients",
  components: {
    BasePhoneInput,
    MapComponent,
  },
  data() {
    return {
      key: null,
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      isWhatsappSame: false,
      // Start:: Image Modal Control Data
      dialogImage: false,
      selectedItemImage: null,
      // End:: Image Modal Control Data
      // Start:: Data Collection To Send
      data: {
        image: null,
        commercial_registration_image: null,
        tax_number_image: null,
        phone: null,
        client_name: null,
        commercial_registration_number: null,
        tax_number: null,
        region_name: null,
        city_name: null,
        district_name: null,
        address: null,
        latitude: null,
        longitude: null,
        building_number: null,
        postal_code: null,
        is_active: true,
        created_at: null,
        email: null,
        user_type: null,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // start show data
    async showClient() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `users/${this.$route.params?.id}?include=roles,region,city,district`,
        });
        const user = res.data.data;
        this.data.client_name = user.name;
        this.data.image = user.avatar;
        this.data.phone = user.phone;
        this.data.commercial_registration_number = user.commercial_registration_number;
        this.data.tax_number = user.tax_number;
        this.data.commercial_registration_image = user.commercial_registration_image || null;
        this.data.tax_number_image = user.tax_number_image || null;
        this.data.region_name = user.region?.name || null;
        this.data.city_name = user.city?.name || null;
        this.data.district_name = user.district?.name || null;
        this.data.address = user.address_details;
        this.data.latitude = user.latitude;
        this.data.longitude = user.longitude;
        this.data.building_number = user.building_number;
        this.data.postal_code = user.postal_code;
        this.data.created_at = user.created_at;
        this.data.email = user.email;
        this.data.is_active = user.status === "active";
        this.data.user_type = user.user_type;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
    dialCode(dialCode) {
      this.data.dial_code = dialCode;
    },

    dialCodeWhatsapp(dialCode) {
      this.data.dial_code_whatsapp = dialCode;
    },
    // Start:: Control Image Modal
    showImageModal(image) {
      this.dialogImage = true;
      this.selectedItemImage = image;
    },
    // End:: Control Image Modal
  },
  
  async created() {
    // Start:: Fire Methods
    this.showClient();
    // End:: Fire Methods;
  },
};
</script>

<style scoped>
.preview-container {
  margin-bottom: 2rem;
}

.image-label {
  color: #E1423D;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 1rem;
}

.image-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */
  transition: all 0.3s ease;
  max-width: 100%;
}

.image-wrapper:hover {
  box-shadow: 0 6px 20px rgba(225, 66, 61, 0.3);
  transform: translateY(-2px);
}

.image-wrapper:hover .image-overlay {
  opacity: 1;
}

.preview-image {
  display: block;
  max-width: 100%;
  height: auto;
  max-height: 400px;
  width: 100%;
  object-fit: contain;
  background: #f5f5f5;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(225, 66, 61, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: white;
}

.image-overlay i {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.image-overlay span {
  font-size: 0.9rem;
  font-weight: 500;
}

@media (max-width: 768px) {
  .preview-image {
    max-height: 300px;
  }
  
  .image-label {
    font-size: 14px;
  }
}
</style>
